module.exports = __webpack_public_path__ + "static/img/14000760.b5b9ed25.png";